import React, { useState } from 'react';
import styled from 'styled-components';
import { ModalV2 } from 'components/ModalV2/ModalV2';

const Container = styled.div`
  background: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme.colors.background.secondary
      : '#fff'};
  border-radius: ${(props) => props.theme.borderRadius.xl};
  padding: 32px 24px;
  max-width: 500px;
  width: 90vw;
  box-shadow: ${(props) => props.theme.shadows.xl};
`;

const Title = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.text.primary};
  text-align: center;
  margin-bottom: 24px;
`;

const OptionCard = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 30px;
  border-radius: ${(props) => props.theme.borderRadius.md};
  background: ${(props) =>
    props.isSelected ? props.theme.colors.primary : 'transparent'};
  border: 1px solid
    ${(props) =>
      props.isSelected
        ? props.theme.colors.primary
        : props.theme.colors.card.border};
  color: ${(props) =>
    props.isSelected
      ? props.theme.colors.text.white
      : props.theme.colors.text.primary};
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 12px;
  transition: ${(props) => props.theme.transitions.fast};

  &:hover {
    background: ${(props) =>
      props.isSelected
        ? props.theme.colors.primary
        : props.theme.colors.interactive.hoverBackground};
  }
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const ContinueButton = styled.button`
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  padding: 12px 40px;
  border-radius: ${(props) => props.theme.borderRadius.md};
  border: none;
  background: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.text.white};
  cursor: pointer;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
`;

const OPTIONS = [
  { label: 'Janam Scanner', value: 'janam' },
  { label: 'Phone Camera', value: 'phone' },
];

export const ScannerSelectModal = ({
  isVisible,
  setIsVisible,
  setSelectedOption,
}) => {
  const [selected, setSelected] = useState(null);

  const handleContinue = () => {
    if (!selected) return;
    setSelectedOption(selected);
    setIsVisible(false);
  };

  // Prevent closing without selection — use onClose as noop
  // eslint-disable-next-line no-empty-function
  const noop = () => {};

  return (
    <ModalV2
      isOpen={isVisible}
      onClose={noop}
      closeOnOverlayClick={false}
      closeOnEsc={false}
    >
      <Container>
        <Title>Which type of scanner are you using?</Title>
        {OPTIONS.map((option) => (
          <OptionCard
            key={option.value}
            isSelected={selected === option.value}
            onClick={() => setSelected(option.value)}
          >
            {option.label}
          </OptionCard>
        ))}
        <ButtonRow>
          <ContinueButton onClick={handleContinue} disabled={!selected}>
            Continue
          </ContinueButton>
        </ButtonRow>
      </Container>
    </ModalV2>
  );
};
